import React from "react";
import styled from "styled-components";
import { Form, Row, Col } from "react-bootstrap";

import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import Button from "../../../styled/Button";

const StyledOrderStatusRequestForm = styled(Form)`
  padding-bottom: 62px;

  .inputs-block-title {
    margin-bottom: 16px;
    padding-left: 24px;
    padding-right: 24px;

    font-family: 'RobotoBold';
    font-size: 24px;
    line-height: calc(1.42857rem * (24 / 16));
    text-align: center;
    text-transform: capitalize;
    color: #424242;

    span {
      span {
        color: #C61F0C;
      }
    }
  }

  .input-title {
    margin-bottom: 4px;
    font-family: 'RobotoRegular';
    font-size: 14px;
    line-height: calc(1.42857rem * (14 / 16));
    color: ${hexToRGBA('#424242', 0.5)};
    caret-color: ${hexToRGBA('#424242', 0.5)};
  }

  .inputs-block-divider {
    margin-bottom: 46px;
  }

  .top-disclaimer {
    font-family: 'RobotoRegular';
    text-align: center;
    color: #424242;

    span {
      display: block;
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }

  .bottom-disclaimer {
    font-family: 'RobotoRegular';
    font-size: 10px;
    line-height: calc(1.42857rem * (10 / 16));
    text-align: center;
    color: #424242;
    opacity: 0.5;
  }

  button {
    width: 100%;
    margin-bottom: 1rem;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    padding-bottom: 42px;
  }
`;

function OrderStatusRequestForm({ values = {}, onChange, onSubmit }) {
  return (
    <StyledOrderStatusRequestForm
      noValidate
      validated={values.validated}
      onSubmit={onSubmit}
    >
      <Row>
        <Col xs={12}>
          <div className="inputs-block-divider" />
        </Col>
        <Col xs={12}>
          <div className="inputs-block-title">
            <span>
              Enter order number used in your application
            </span>
          </div>
        </Col>
        <Col xs={12}>
          <div className="top-disclaimer">
            <span>
              Please enter your order number to check the status of your application or receive your EIN/Tax ID Number
            </span>
          </div>
        </Col>
        <Col xs={12}>
          <div className="inputs-block-divider" />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <TextInput
            id="orderNumber"
            required
            label="Order Number"
            placeholder="Enter Order Number"
            defaultInvalidMessage="Please enter order number"
            value={values.orderNumber}
            onChange={onChange}
          />
        </Col>
        <Col xs={12}>
          <div className="inputs-block-divider" />
        </Col>
      </Row>
      <Row>
        <Col xs={0} md={3} />
        <Col xs={12} md={6}>
          <Button type="submit">
            Submit
          </Button>
        </Col>
        <Col xs={0} md={3} />
      </Row>
    </StyledOrderStatusRequestForm>
  );
}

export default OrderStatusRequestForm;
